import { LumenButton } from '@photoshelter/socialie-components';
import SendSubmissionsToGallery from 'components/SendSubmissionsToGallery';
import { useTranslation } from 'react-i18next';
import Submission from 'types/Submission';
import UgcRequest from 'types/UgcRequest';
import { SubmissionSidebarDownload } from './SubmissionSidebar/components';
import { useState } from 'react';
import SubmissionDeleteModal from 'components/SubmissionDeleteModal';
import SubmissionRating from 'components/SubmissionRating';

interface Props {
  submission?: Submission;
  ugcRequest: UgcRequest;
  onClose: () => void;
  isSidebarOpen: boolean;
  onToggleSidebar: () => void;
}

export default function SubmissionTopBar(props: Props) {
  const { submission, ugcRequest, onClose, isSidebarOpen, onToggleSidebar } =
    props;
  const { t } = useTranslation();

  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  return (
    <>
      <div className="flex h-(--submission-topbar-height) w-full shrink-0 items-center border-b bg-background py-1 pr-1 pl-3 text-foreground">
        <div>{ugcRequest.subject}</div>
        <div className="ml-auto flex items-center gap-1">
          {submission && (
            <div className="ml-auto flex items-center gap-1 border-l pl-2">
              <SendSubmissionsToGallery
                submissions={[submission]}
                renderTrigger={
                  <LumenButton
                    color="outline"
                    leftIcon="send-outline"
                    size="sm"
                  >
                    {t('ugcRequestShow.submissions.sidebar.sendToGallery')}
                  </LumenButton>
                }
              />

              <SubmissionRating
                theme="topbar"
                submission={submission}
                keyboard
              />

              <SubmissionSidebarDownload submission={submission} />

              <LumenButton
                color="transparent"
                size="sm"
                aria-expanded={isSidebarOpen}
                aria-label={t('ugcRequestShow.submissions.sidebar.toggle')}
                leftIcon="info-outline"
                onClick={() => onToggleSidebar()}
              />

              <LumenButton
                color="transparent"
                size="sm"
                aria-expanded={isDeleteModalOpen}
                leftIcon="trash-outline"
                aria-label={t('ugcRequestShow.submissions.sidebar.delete')}
                onClick={() => setIsDeleteModalOpen(true)}
              />
            </div>
          )}
          <div className="border-l pl-1">
            <LumenButton
              color="transparent"
              size="sm"
              aria-label={t('ugcRequestShow.submissions.sidebar.close')}
              leftIcon="close"
              onClick={() => onClose()}
            />
          </div>
        </div>
      </div>

      {submission && (
        <SubmissionDeleteModal
          ugcRequest={ugcRequest}
          submissions={[submission]}
          isOpen={isDeleteModalOpen}
          onRequestClose={() => setIsDeleteModalOpen(false)}
          onAfterDelete={onClose}
        />
      )}
    </>
  );
}
